import Image from 'next/image'

import { formatBigInt, NumberType } from '../utils/formatNumbers'

export const TvlBreakdownTooltipContent = ({
  usdeTvlData,
  usdtbTvlData,
}: {
  usdeTvlData: bigint | undefined
  usdtbTvlData: bigint | undefined
}) => {
  return (
    <div className="flex flex-col gap-1 text-white">
      <h2 className="font-medium text-sm">TVL Consists of:</h2>
      <div className="flex items-center gap-1 text-xs">
        <Image src="/shared/usde.svg" width={16} height={16} alt="USDe" className="h-4 w-4" />
        <p>USDe:</p>
        <p className="font-medium">
          {usdeTvlData ? (
            formatBigInt(usdeTvlData, 'USDe', NumberType.FiatTokenAmt)
          ) : (
            <span className="font-thin">Loading...</span>
          )}
        </p>
      </div>
      <div className="flex items-center gap-1 text-xs">
        <Image src="/shared/usdtb.svg" width={16} height={16} alt="USDtb" className="h-4 w-4" />
        <p>USDtb:</p>
        <p className="font-medium">
          {usdtbTvlData ? (
            formatBigInt(usdtbTvlData, 'USDtb', NumberType.FiatTokenAmt)
          ) : (
            <span className="font-thin">Loading...</span>
          )}
        </p>
      </div>
    </div>
  )
}
